import React from 'react';

import IMG_NHS from 'assets/tags/discount.svg';
import IMG_SPARKLE from 'assets/tags/sparkle-dark.png';
import IMG_LABEL from 'assets/tags/unicorn.png';
import IMG_VIDEO_ICON from 'assets/tags/video-icon.svg';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ClientTagsSplashVideo.module.scss';

const VIDEO_LINK = 'https://player.vimeo.com/video/770496473?h=c278812f12&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

const ClientTagsSplashVideo = ({ isGBSalon }) => {
  const { t } = useTranslation();

  return (
    <section data-bem="ClientTagsSplashVideo" className={CN.container}>
      <div className={CN.title} data-bem="ClientTagsSplashVideo__title">
        {t('clientTags.splashPage.videoSplash.title')}
        {S.space}
        <span className={CN.violet}>{t('clientTags.splashPage.videoSplash.subtitle')}</span>
      </div>

      <div className={CN.inner} data-bem="ClientTagsSplashVideo__inner">
        <div className={CN.videoContainer} data-bem="ClientTagsSplashVideo__video">
          <img src={IMG_LABEL} className={CN.imgLabel} alt="Unicorn  Loyalty club" />
          <img src={IMG_VIDEO_ICON} className={CN.imgVideoIcon} alt="Video icon" />
          <iframe className={CN.video} src={VIDEO_LINK} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title={t('clientTags.splashPage.videoSplash.videoTitle')} />
        </div>
        {isGBSalon && (
          <div className={CN.imgContainer} data-bem="ClientTagsSplashVideo__img-container">
            <img src={IMG_SPARKLE} className={CN.imgSparkle} alt="Sparkle" data-bem="ClientTagsSplashVideo__img-sparkle" />
            <img src={IMG_NHS} className={CN.imgNHS} alt="Graphics map discount icon" />
          </div>
        )}
      </div>
    </section>
  );
};
export default ClientTagsSplashVideo;
